import { baseUrls, apiUrls } from "../utils/Endpoints.config";
import {
  postRequest,
  callApi,
} from "../core/resource/services/apiService";
import { getDataFromLocalstorage, removeDataFromLocalstorage } from './AppHelper';
import Cookies from 'js-cookie';

const header = {
  authorization: "",
};
let additionalParams = {
  isInterceptors: false,
  isPassword: false
}

const getAccessTokenData = () => {
  return getDataFromLocalstorage("authtoken");
}
const getClientTypeAndId = (params) => {
  const clientId = params?.email ? window.btoa(params?.email) : 'g123456'
  return {
    client_id: clientId,
    client_type: "web",
  };
};


const logoutUser = async () => {
  const accessTokenData = getAccessTokenData();
  // const accessTokenData = '';

  const url = `${baseUrls.main}/${apiUrls.auth.logout}`;
  const options = postRequest({
    // account_id: accessTokenData?.account_id || '',
    // token_type: "access",
  });
  // header.authorization = accessTokenData?.token || '';
  header.authorization = accessTokenData || '';

  const res = await callApi(url, options, header);

  removeDataFromLocalstorage('authtoken');
  removeDataFromLocalstorage('user');
  Cookies.remove('authtoken')
  Cookies.remove('authData')
  // redirect to login page
  window.location.replace('/login');



  return res;
};

export {
  getAccessTokenData,
  getClientTypeAndId,
  logoutUser,
};
